import { Injectable } from '@angular/core';

import {HttpService} from '../http.service';
import {Observable, throwError} from 'rxjs';
import {PendingPaymentRequestResponse} from '../../shared/models/PendingPaymentRequestResponse.model';
import {catchError} from 'rxjs/operators';
import {DeliveryMethod} from '../../dashboard/shared/holding/capital-call/models';

@Injectable({
  providedIn: 'root'
})
export class LpPaymentRequestDataService {

  constructor(private http: HttpService) { }

  getPendingPaymentRequests(): Observable<PendingPaymentRequestResponse[]> {
    return this.http.getTyped<PendingPaymentRequestResponse[]>('paymentRequest').pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getPendingPaymentRequestsForHolding(holdingId: number): Observable<PendingPaymentRequestResponse[]> {
    return this.http.getTyped<PendingPaymentRequestResponse[]>(`paymentRequest/holding/${holdingId}`).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getDeliveryMethodsForCountry(paymentToken: string, countryId: number): Observable<DeliveryMethod> {
    return this.http.getTyped<DeliveryMethod>(`paymentRequest/${paymentToken}/delivery-method/${countryId}`).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  markPaymentRequestsAsViewed(paymentTokens: string[]) {
    return this.http.postTyped('paymentRequest/viewed', paymentTokens).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  public downloadPaymentRequestPdf(paymentToken: string){
    return this.http.downloadFile(`paymentRequest/${paymentToken}/bank-account-details`, 'application/pdf')
    .pipe(catchError(err => {
      return throwError(err);
    }));
  }
}
